import React from 'react';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import {
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-common';
import {
  SYS_BORDER_RADIUS_MD,
  SYS_COLOR_TEXT_CAPTION_DEFAULT_DARK,
  SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
  SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
} from '@oneaudi/unified-web-alpha-common';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';

export const TileContainer = styled.div`
  ${dynamicStyling({
    alpha: `
      display: flex;
      flex-direction: column;
      background: ${SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK};
      border-radius: ${SYS_BORDER_RADIUS_MD};`,
  })}
  position: relative;
  overflow: visible;

  svg {
    transform: scale(1);
  }
`;

export const TileContent = styled.div`
  ${dynamicStyling({
    legacy: `padding: 0 ${SYS_SPACE_FIXED_200}`,
    alpha: `
        padding: ${SYS_SPACE_FIXED_200};
        flex: 1 1 auto;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        `,
  })};
`;

export const AlphaWrapper = styled.div``;
export const StyledTileHeadlineArea = styled.div`
  margin-bottom: ${SYS_SPACE_FIXED_300};
`;

export const StyledLink = styled(TextLink)`
  text-decoration: none;
  ${dynamicStylingHelper(``, `padding-bottom: 0;`)};
  color: ${dynamicStylingHelper(
    SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT,
    SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK
  )};

  & :hover {
    color: ${dynamicStylingHelper(
      SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
      SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK
    )};
  }
`;

export const GreyText = styled((props) => (
  <Text
    {...props}
    variant={{
      order: dynamicStylingHelper('2', '3'),
      style: 'normal',
      type: 'copy',
    }}
  />
))`
  color: ${dynamicStylingHelper('#333333;', SYS_COLOR_TEXT_CAPTION_DEFAULT_DARK)};
  ${dynamicStylingHelper(`margin-bottom: ${SYS_SPACE_FIXED_350};`)};
`;
